export default __webpack_public_path__ + "static/template-starters-dee419d4c5377e4aea9f7287813a05cb.mp4";